var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#B2D235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C14.8995 4.5 17.25 6.85051 17.25 9.75C17.25 11.1802 16.6781 12.4769 15.7505 13.4238L15.7494 18.9376C15.7494 19.3666 15.2944 19.6279 14.9302 19.4385L14.8631 19.3976L11.9993 17.3818L9.13699 19.3975C8.78624 19.6446 8.31055 19.423 8.2558 19.016L8.2506 18.9376L8.24953 13.4238C7.32192 12.4769 6.75 11.1802 6.75 9.75C6.75 6.85051 9.10051 4.5 12 4.5ZM14.6244 17.8538L14.6246 14.2979C13.8525 14.7444 12.9561 15 12 15C11.0439 15 10.1475 14.7444 9.37544 14.2979L9.3756 17.8535L11.6753 16.2339C11.8453 16.1143 12.065 16.0993 12.2474 16.189L12.323 16.2339L14.6244 17.8538L14.6246 14.2979L14.6244 17.8538ZM12 5.625C9.72183 5.625 7.875 7.47183 7.875 9.75C7.875 12.0282 9.72183 13.875 12 13.875C14.2782 13.875 16.125 12.0282 16.125 9.75C16.125 7.47183 14.2782 5.625 12 5.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesIcon);
export default __webpack_public_path__ + "static/media/badgesIcon.066940a1.svg";
export { ForwardRef as ReactComponent };